<div class="flex mx-4 text-dark">
  <app-button class="mr-1" (click)="selectPreviousItem()">
    <svg viewBox="0 0 16 16" class="w-4 h-4">
      <path fill="currentColor" fill-rule="nonzero"
        d="M10.53 2.47a.75.75 0 00-.98-.07l-.08.07-5 5a.75.75 0 00-.07.98l.07.08 5 5a.75.75 0 001.13-.98l-.07-.08L6.06 8l4.47-4.47a.75.75 0 00.07-.98l-.07-.08z"/>
    </svg>
  </app-button>
  @if (!mobile) {
    <app-project-reference-carousel-page class="mr-2 ml-1" [dark]="dark" [references]="visibleReferences"></app-project-reference-carousel-page>
  }
  <app-button (click)="selectNextItem()">
    <svg viewBox="0 0 16 16" class="w-4 h-4">
      <path fill="currentColor" fill-rule="nonzero"
        d="M5.47 2.47a.75.75 0 01.98-.07l.08.07 5 5c.27.27.29.68.07.98l-.07.08-5 5a.75.75 0 01-1.13-.98l.07-.08L9.94 8 5.47 3.53a.75.75 0 01-.07-.98l.07-.08z"/>
    </svg>
  </app-button>
</div>

